var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c("v-card-title", [
        _c("span", { staticClass: "headline" }, [
          _vm._v("Create Service Account"),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c(
            "v-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
              model: {
                value: _vm.validUser,
                callback: function ($$v) {
                  _vm.validUser = $$v
                },
                expression: "validUser",
              },
            },
            [
              _c(
                "v-container",
                { attrs: { "grid-list-md": "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm6: "", md6: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              rules: [_vm.rules.required],
                              label: "Name",
                            },
                            model: {
                              value: _vm.editedItem.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.editedItem, "name", $$v)
                              },
                              expression: "editedItem.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm6: "", md6: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Username",
                              "prepend-icon": "fas fa-user",
                              rules: [
                                _vm.rules.required,
                                _vm.rules.duplicate,
                                _vm.rules.formatLogin,
                              ],
                            },
                            model: {
                              value: _vm.editedItem.login,
                              callback: function ($$v) {
                                _vm.$set(_vm.editedItem, "login", $$v)
                              },
                              expression: "editedItem.login",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm6: "", md6: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              autocomplete: "new-password",
                              rules: [_vm.rules.required, _vm.rules.format],
                              "prepend-icon": "fas fa-lock",
                              type: "password",
                              label: "Password",
                            },
                            model: {
                              value: _vm.editedItem.password,
                              callback: function ($$v) {
                                _vm.$set(_vm.editedItem, "password", $$v)
                              },
                              expression: "editedItem.password",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm6: "", md6: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              rules: [_vm.rules.required, _vm.rules.match],
                              type: "password",
                              label: "Confirm Password",
                            },
                            model: {
                              value: _vm.confirmPassword,
                              callback: function ($$v) {
                                _vm.confirmPassword = $$v
                              },
                              expression: "confirmPassword",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-actions",
        [
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: {
                color: "primary",
                rounded: "",
                disabled: !_vm.validUser,
                loading: _vm.saving,
              },
              nativeOn: {
                click: function ($event) {
                  return _vm.save.apply(null, arguments)
                },
              },
            },
            [_vm._v("Save")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }